export default {
    LOGIN_USER({ commit }, state){
        commit('LOGIN_USER_MUTATION', state)
    },
    LOGOUT({ commit }, state){
        commit('LOGOUT_MUTATION', state)
    },
    LOCALES({ commit }, state){
        commit('LOCALES_MUTATION', state)
    },
    OVERVIEW({ commit }, state){
        commit('OVERVIEW_MUTATION', state)
    },
    IMPRESSUM({ commit }, state){
        commit('IMPRESSUM_MUTATION', state)
    },
    OBJECTS({ commit }, state, page){
        commit('OBJECTS_MUTATION', state, page)
    },
    OBJECT_PACKETS({ commit }, state){
        commit('OBJECT_PACKETS_MUTATION', state)
    },
    TINY_OBJECTS({ commit }, state){
        commit('TINY_OBJECTS_MUTATION', state)
    },
    AVAILABLE_FILTERS({ commit }, state){
        commit('AVAILABLE_FILTERS_MUTATION', state)
    },
    NOTIFICATIONS_COUNT({ commit }, state){
        commit('NOTIFICATIONS_COUNT_MUTATION', state)
    },
    ASSESSMENT_COUNT({ commit }, state){
        commit('ASSESSMENT_COUNT_MUTATION', state)
    },
    QUERIES({ commit }, state){
        commit('QUERIES_MUTATION', state)
    },
    QUERIES_BY_SEARCHVALUE({ commit }, state){
        commit('QUERIES_MUTATION_SEARCH', state)
    },
    SEPA_MISSING_INFO({ commit }, state){
        commit('SEPA_MISSING_INFO_MUTATION', state)
    },
    SEPA_DETAILS({ commit }, state){
        commit('SEPA_DETAILS_MUTATION', state)
    },
}
